import { getLogger } from '@confluence/logger';

const logger = getLogger('retrieveContentExtensionMetrics');

export type ContentExtensionCount = {
	connect: Record<string, number>;
	forge: Record<string, number>;
};

export type ContentExtensionKeys = {
	connect: string[];
	forge: string[];
};

type Node = {
	type?: any;
	attrs?: {
		extensionType?: string;
		extensionKey?: string;
	};
};

export type ContentExtensionMetrics = {
	contentExtensionCount: ContentExtensionCount;
	contentExtensionKeys: ContentExtensionKeys;
	hasExtensions: boolean;
};

export const retrieveContentExtensionMetrics = (contentBody: string) => {
	try {
		const contentExtensionMetrics: ContentExtensionMetrics = {
			contentExtensionCount: {
				connect: {},
				forge: {},
			},
			contentExtensionKeys: {
				connect: [],
				forge: [],
			},
			hasExtensions: false,
		};
		const document = JSON.parse(contentBody);
		document?.content?.forEach((node: Node) => {
			retrieveContentExtensionMetricsFromNode(node, contentExtensionMetrics);
		});
		return contentExtensionMetrics;
	} catch {
		logger.error`Unable to parse ADF`;
		return {};
	}
};

export const retrieveContentExtensionMetricsFromNode = (
	node: Node,
	contentExtensionMetrics: ContentExtensionMetrics,
) => {
	retrieveContentExtensionCountFromNode(node, contentExtensionMetrics.contentExtensionCount);
	retrieveContentExtensionKeysFromNode(node, contentExtensionMetrics.contentExtensionKeys);
	contentExtensionMetrics.hasExtensions =
		contentExtensionMetrics.contentExtensionKeys?.connect.length > 0 ||
		contentExtensionMetrics.contentExtensionKeys?.forge.length > 0;
	return contentExtensionMetrics;
};

function retrieveContentExtensionKeysFromNode(
	{ attrs, type }: Node,
	contentExtensionKeys: ContentExtensionKeys,
) {
	if (attrs && type) {
		const { extensionType, extensionKey } = attrs;
		// Forge extensions have extensionType of 'com.atlassian.ecosystem' whereas Connect extensions have 'com.atlassian.confluence.macro.core'.
		if (extensionType === 'com.atlassian.ecosystem' && extensionKey) {
			contentExtensionKeys.forge.push(extensionKey);
		} else if (extensionType === 'com.atlassian.confluence.macro.core' && extensionKey) {
			contentExtensionKeys.connect.push(extensionKey);
		} else {
			return;
		}
	}
}

function retrieveContentExtensionCountFromNode(
	{ attrs, type }: Node,
	contentExtensionCount: ContentExtensionCount,
) {
	if (attrs && type) {
		const { extensionType } = attrs;

		// Forge extensions have extensionType of 'com.atlassian.ecosystem' whereas Connect extensions have 'com.atlassian.confluence.macro.core'.
		let extensionsObj: undefined | ContentExtensionCount[keyof ContentExtensionCount];
		if (extensionType === 'com.atlassian.ecosystem') {
			extensionsObj = contentExtensionCount.forge;
		} else if (extensionType === 'com.atlassian.confluence.macro.core') {
			extensionsObj = contentExtensionCount.connect;
		} else {
			return;
		}

		if (extensionsObj) {
			extensionsObj[type] = (extensionsObj[type] || 0) + 1;
		}
	}
}
